module.exports = __webpack_public_path__ + "static/media/mukul-kumar.07689598.jpeg";